import { render, staticRenderFns } from "./editAssociationForm.vue?vue&type=template&id=080ecd06&scoped=true"
import script from "./editAssociationForm.vue?vue&type=script&lang=js"
export * from "./editAssociationForm.vue?vue&type=script&lang=js"
import style0 from "./editAssociationForm.vue?vue&type=style&index=0&id=080ecd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ecd06",
  null
  
)

export default component.exports